import { createSafeContext } from '@/util';

import type { VContextMenuContextValue } from './type';

export const VContextMenuContext = createSafeContext<VContextMenuContextValue>(
  null,
  'VContextMenuContext',
);
